export function Version() {
	return (
		<div>
			<p className="text-gray-600">Versão 1.0.4</p>
		</div>
	);
}
